/** Optional client-side filters for real, editor-maintained career listings. */
if (!customElements.get('anio-career-jobs')) {
  customElements.define('anio-career-jobs', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const filters = this.querySelector('[data-career-filters]');
      const jobs = [...this.querySelectorAll('[data-career-job]')];
      const status = this.querySelector('[data-career-status]');
      if (!filters || !jobs.length) return;
      filters.hidden = filters.querySelectorAll('button').length < 3;
      filters.addEventListener('click', event => {
        const button = event.target.closest('button[data-career-filter]');
        if (!button || !filters.contains(button)) return;
        const value = button.dataset.careerFilter;
        filters.querySelectorAll('button').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        let count = 0;
        jobs.forEach(job => {
          job.hidden = value !== 'all' && job.dataset.category !== value;
          if (!job.hidden) count++;
        });
        if (status) {
          const label = count === 1 ? this.dataset.statusOne : this.dataset.statusOther;
          status.textContent = (label || `[count] ${count === 1 ? 'Stelle' : 'Stellen'} angezeigt.`).replaceAll('[count]', String(count));
        }
      }, { signal: this.abort.signal });
    }
    disconnectedCallback() { this.abort?.abort(); }
  });
}
